import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { SendIcon, CheckCircle2, MailIcon, MapPinIcon } from 'lucide-react';
const reasons = ['General enquiry', 'Business partnership', 'Press & media', 'Bug report', 'Feature request', 'Other'];
export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    reason: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-305" data-mp="a9aaut7yjz8d">
      <SEO title="Contact | KittyPot" description="Get in touch with the KittyPot team. KittyPot helps groups track shared expenses, split costs fairly, and see the simplest way to settle up." ogTitle="Contact KittyPot" ogDescription="Track shared expenses, split costs fairly, and see the simplest way to settle up." path="/contact" data-id="element-306" data-mp="19h0ni0tl5lpt" />
      <Navbar data-id="element-307" data-mp="mhmdjtt3zrq5" />
      <main className="pt-36 pb-24" data-id="element-308" data-mp="mi5j0b1konna">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-309" data-mp="mixc9f7p69ae">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="text-center mb-14" data-id="element-310" data-mp="qiobm7bahxqj">
            <h1 className="text-4xl md:text-5xl font-black text-kitty-dark mb-4 tracking-tight" data-id="element-311" data-mp="10e9c210pmpy6">
              Contact KittyPot
            </h1>
            <p className="text-lg text-gray-500 max-w-md mx-auto" data-id="element-312" data-mp="2bups9wk39am3">
              Have a question about KittyPot or early access? Get in touch.
            </p>
          </motion.div>

          <div className="grid lg:grid-cols-5 gap-10 items-start" data-id="element-313" data-mp="1h8isiassfov9">
            {/* Contact Form */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="lg:col-span-3" data-id="element-314" data-mp="1w62vxda1dbzb">
              {submitted ? <div className="bg-white rounded-2xl p-10 md:p-14 shadow-card border border-gray-100 text-center" data-id="element-315" data-mp="13ej5b8b40vna">
                  <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-6" data-id="element-316" data-mp="1d6f64r4kyzv7">
                    <CheckCircle2 className="w-8 h-8 text-green-600" data-id="element-317" data-mp="18fp0rdw5mx0i" />
                  </div>
                  <h2 className="text-2xl font-bold text-kitty-dark mb-3" data-id="element-318" data-mp="kpun4u40h4f7">
                    Message sent!
                  </h2>
                  <p className="text-gray-500 max-w-sm mx-auto" data-id="element-319" data-mp="fqi0a9d53xcm">
                    Thanks for reaching out. The KittyPot team will get back to
                    you as soon as possible.
                  </p>
                </div> : <form onSubmit={handleSubmit} className="bg-white rounded-2xl p-8 md:p-10 shadow-card border border-gray-100 relative overflow-hidden" data-id="element-320" data-mp="2w6o9rlizvngx">
                  <div className="absolute top-0 left-0 right-0 h-1.5 bg-kitty-yellow" data-id="element-321" data-mp="2mes8k1lm3h8h" />

                  <div className="space-y-6 mt-2" data-id="element-322" data-mp="3a4mkmgy3x1ro">
                    <div data-id="element-323" data-mp="3a5xjq3glxlcg">
                      <label htmlFor="name" className="block text-sm font-semibold text-kitty-dark mb-2" data-id="element-324" data-mp="3f47ggihzcu06">
                        Full Name
                      </label>
                      <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} placeholder="Enter your name" required className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-kitty-yellow focus:border-transparent text-gray-900 placeholder-gray-400 text-base transition-shadow" data-id="element-325" data-mp="3146k9gcnuar1" />
                    </div>

                    <div data-id="element-326" data-mp="29zlqjw4sswnj">
                      <label htmlFor="email" className="block text-sm font-semibold text-kitty-dark mb-2" data-id="element-327" data-mp="2a03sn9e5653d">
                        Email
                      </label>
                      <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} placeholder="Enter your email" required className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-kitty-yellow focus:border-transparent text-gray-900 placeholder-gray-400 text-base transition-shadow" data-id="element-328" data-mp="208zhylvi16ec" />
                    </div>

                    <div data-id="element-329" data-mp="2ixnzqyyoqvlw">
                      <label htmlFor="reason" className="block text-sm font-semibold text-kitty-dark mb-2" data-id="element-330" data-mp="2iww2zktcqru1">
                        Reason for contacting us
                      </label>
                      <select id="reason" name="reason" value={formData.reason} onChange={handleChange} required className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-kitty-yellow focus:border-transparent text-gray-900 text-base transition-shadow appearance-none bg-white bg-[url('data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%239ca3af%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpolyline%20points%3D%226%209%2012%2015%2018%209%22%3E%3C%2Fpolyline%3E%3C%2Fsvg%3E')] bg-[length:20px] bg-[right_12px_center] bg-no-repeat pr-10" data-id="element-331" data-mp="17l3mtllkvmjo">
                        <option value="" disabled data-id="element-332" data-mp="as586fkgtgdy">
                          Select a reason
                        </option>
                        {reasons.map(reason => <option key={reason} value={reason} data-id="element-333" data-mp="fnsxcuyy69jg">
                            {reason}
                          </option>)}
                      </select>
                    </div>

                    <div data-id="element-334" data-mp="2hjd5jcluwlx6">
                      <label htmlFor="message" className="block text-sm font-semibold text-kitty-dark mb-2" data-id="element-335" data-mp="3ks672d73aukq">
                        Message
                      </label>
                      <textarea id="message" name="message" value={formData.message} onChange={handleChange} placeholder="Enter your message" required rows={5} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-kitty-yellow focus:border-transparent text-gray-900 placeholder-gray-400 text-base transition-shadow resize-vertical" data-id="element-336" data-mp="3fvpglccf444h" />
                    </div>

                    <button type="submit" className="w-full bg-kitty-yellow hover:bg-kitty-yellow-500 text-kitty-dark py-4 rounded-full font-bold text-lg transition-all active:scale-[0.98] shadow-md hover:shadow-lg flex items-center justify-center gap-2" data-id="element-337" data-mp="ge7yhlp72uqf">
                      Send Message
                      <SendIcon className="w-5 h-5" data-id="element-338" data-mp="qa2l0rwjh9yh" />
                    </button>
                  </div>
                </form>}
            </motion.div>

            {/* Contact Info Sidebar */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="lg:col-span-2 space-y-6" data-id="element-339" data-mp="14x1eeseyiefu">
              <div className="bg-white rounded-2xl p-7 shadow-card border border-gray-100" data-id="element-340" data-mp="zyq4yiskq5y5">
                <div className="w-10 h-10 rounded-xl bg-kitty-yellow/20 flex items-center justify-center mb-4" data-id="element-341" data-mp="m7up2mjnqol2">
                  <MailIcon className="w-5 h-5 text-kitty-yellow-700" data-id="element-342" data-mp="r0w5x03fcy7a" />
                </div>
                <h3 className="font-bold text-kitty-dark mb-1" data-id="element-343" data-mp="cc025f8ei7ch">Email us</h3>
                <a href="mailto:support@kittypot.com" className="text-gray-500 hover:text-kitty-dark transition-colors text-sm" data-id="element-344" data-mp="h8qdjp99gerk">
                  support@kittypot.com
                </a>
              </div>

              <div className="bg-white rounded-2xl p-7 shadow-card border border-gray-100" data-id="element-345" data-mp="7aaorsxphhl8">
                <div className="w-10 h-10 rounded-xl bg-kitty-yellow/20 flex items-center justify-center mb-4" data-id="element-346" data-mp="nptm36kjcd7i">
                  <MapPinIcon className="w-5 h-5 text-kitty-yellow-700" data-id="element-347" data-mp="it35mi4tjflk" />
                </div>
                <h3 className="font-bold text-kitty-dark mb-1" data-id="element-348" data-mp="drdul2hlj1xh">Our address</h3>
                <address className="not-italic text-gray-500 text-sm leading-relaxed" data-id="element-349" data-mp="8udnco90ft4s">
                  KittyPot Ltd
                  <br data-id="element-350" data-mp="4ssfxif8w71z" />
                  Flat 2 Minavon
                  <br data-id="element-351" data-mp="1abgke0joc9" />
                  Cardiff, CF14 6BE
                  <br data-id="element-352" data-mp="3w5dbtvlzzdht" />
                  United Kingdom
                </address>
              </div>

              <div className="bg-gray-950 rounded-2xl p-7 text-white" data-id="element-353" data-mp="3r7v1c0sc0q7p">
                <p className="text-sm font-medium mb-1" data-id="element-354" data-mp="3m9jpjkih85mu">Response time</p>
                <p className="text-gray-400 text-sm" data-id="element-355" data-mp="3h9xd3dah2tf3">
                  We typically reply within 24 hours on business days.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </main>
      <Footer data-id="element-356" data-mp="1soqa5qnpb17v" />
    </div>;
}